/*
 * Clive: keeps the `_Pre-order-ETA` line item property in step with the selected variant
 * (Dani, 2026-10-15). snippets/product-form.liquid renders one hidden input per pre-order
 * variant, all disabled except the server-selected one; theme.js serialize() skips disabled
 * fields, so exactly one (or none, for an in-stock variant) is posted with the add.
 */
(function () {
  document.addEventListener('product:variant-change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    var forms = document.querySelectorAll('[data-product-form]');
    for (var i = 0; i < forms.length; i++) {
      var form = forms[i];
      // theme.js dispatches on document with no section scope — only touch the form that
      // owns this variant.
      if (!form.querySelector('option[value="' + variant.id + '"]')) continue;
      var inputs = form.querySelectorAll('[data-clive-preorder-variant-id]');
      for (var j = 0; j < inputs.length; j++) {
        inputs[j].disabled = inputs[j].getAttribute('data-clive-preorder-variant-id') !== String(variant.id);
      }
    }
  });
})();
